import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";

export const createArticleGroup = async (data) => {
  const res = await axios.post(`${ApiLink.API_URL}ArticleGroup/newGroup`, data, {
    headers: authHeader(),
  });
  if (!res.data || res.data.toString().toLowerCase().includes("error")) {
    throw new Error(res.data || "Insert failed");
  }
  return res.data;
};

export const updateArticleGroup = async (data) => {
  const res = await axios.put(`${ApiLink.API_URL}ArticleGroup/editGroup`, data, {
    headers: authHeader(),
  });
  if (!res.data || res.data.toString().toLowerCase().includes("error")) {
    throw new Error(res.data || "Update failed");
  }
  return res.data;
};

export const deleteArticleGroup = async (id) => {
  const res = await axios.delete(`${ApiLink.API_URL}Articlegroup/${id}`, {
    headers: authHeader(),
  });

  // Kontrollo suksesin nga backend
  if (!res.data.success) {
    throw new Error(res.data.message || "Delete failed");
  }

  return res.data.message;
};
